import { Hint } from '@systemeio/ui'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import ButtonLikeLink from '../button-like-link'
import { getAccountRestrictedLink } from 'shared/utils/get-account-restricted-link'
import TransLoco from '../trans-loco'
import LinkWithoutPrefetch from '../link-without-prefetch'

export const RestrictionBanner = () => {
  const { user, isRestrictedUser } = useUser()
  const { t } = useLocoTranslation()

  if (!user) return null
  if (!isRestrictedUser) return null

  return (
    <div className="bg-danger/15 border-b-danger text-danger min-h-4 z-10 flex w-full items-center justify-center border-b px-4 py-1 sm:px-6 md:px-14">
      <span className={'fill-danger flex flex-wrap items-center'}>
        <Hint
          className="flex-wrap"
          label={
            <ButtonLikeLink
              onClick={() => window.open(getAccountRestrictedLink(user?.dashboardLocale))}
            >
              {t('global.read_more')}
            </ButtonLikeLink>
          }
        >
          <TransLoco
            t={t}
            i18nKey={'dashboard.notifications.account_restricted'}
            components={{
              a: <LinkWithoutPrefetch href={`/profile/user-plan`} className={'primary-link'} />,
            }}
          />
        </Hint>
      </span>
    </div>
  )
}
